module.exports = __webpack_public_path__ + "static/bnr_wide@2x-77d4a767e055cafdc9bf2609e187f186.webp";